import { gql } from 'graphql-request'

export const LINKS_EXTERNOS = gql`
  query LinksExternosQuery($id: ID!) {
    linksExternosByProduto(id: $id) {
      id
      label
      uri
      uriHomolog
    }
  }
`
